import { Button, Col, Form, message, Modal, Row, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function AssignVehicleModal({
  open = false,
  onUpdated = () => {},
  onCancel = () => {},
  rideId,
}) {
  const [drivers, setDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  const handleAssign = async (values) => {
    const driverId = values.driver.value;
    const vehicleId = values.vehicle.value;
    let res = await apiRequest({
      path: apiPaths.rides + "/" + rideId + "/assign-driver",
      method: "POST",
      data: {
        id_driver: driverId,
        id_vehicle: vehicleId,
      },
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    onUpdated({
      ...res,
      driver: {
        id_user: values.driver.value,
        user_email: values.driver.label,
      },
      vehicle: {
        id: values.vehicle.value,
        name: values.vehicle.label,
      },
    });
  };

  const fetchAvailableDrivers = async () => {
    const res = await apiRequest({
      path: apiPaths.drivers,
    });
    setDrivers(res.results || []);
  };

  const fetchVehicles = async () => {
    const res = await apiRequest({
      path: apiPaths.vehicles + `/Barc`,
    });
    setVehicles(res.results || []);
  };

  useEffect(() => {
    fetchAvailableDrivers();
    fetchVehicles();
  }, []);

  return (
    <Modal
      title={`Assign Driver to a Ride`}
      centered
      //   width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form layout="vertical" onFinish={handleAssign} initialValues={{}}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Driver"
              name="driver"
              rules={[
                {
                  required: true,
                  message: "Please select driver",
                },
              ]}
            >
              <Select
                showSearch
                labelInValue
                placeholder="Search and Select Driver"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "").includes(input)
                }
                options={drivers.map((driver) => ({
                  value: driver.user_id,
                  label: driver.user_email,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Vehicle"
              name="vehicle"
              rules={[
                {
                  required: true,
                  message: "Please select vehicle",
                },
              ]}
            >
              <Select
                showSearch
                labelInValue
                placeholder="Search and Select Vehicle"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "").includes(input)
                }
                options={vehicles.map((vehicle) => ({
                  value: vehicle.id,
                  label: vehicle.name,
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 10,
            }}
          >
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {"Assign"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AssignVehicleModal;
